import { Button, tvar } from '@versita/frontend/campus-ui-web';
import { rgba } from 'polished';
import styled from 'styled-components';

export const StyledAddToCalendarButton = styled(Button)`
  max-width: 25rem;
  margin: auto auto 0;
  border-color: transparent;
  padding: ${tvar('space.x3')} ${tvar('space.x2')};

  img {
    display: inline-block;
    margin: 0 ${tvar('space.x1')} ${tvar('space.x2')};
    width: 2.5rem;
    height: 2.5rem;
  }

  span {
    display: block;
    color: ${tvar('colors.typography.default')};
    border-right: solid 0;
    font-size: ${tvar('typographies.large.fontSize')};
    letter-spacing: 0.03em;
    font-weight: 300;
    transition: 0.2s color ease-in-out;
  }

  &:hover {
    border-color: ${tvar('colors.typography.link')};
    background: ${({ theme }) => rgba(theme.colors.typography.link, 0.02)};

    span {
      color: ${tvar('colors.typography.link')};
    }
  }
`;

export const StyledCalendarLink = styled.input`
  border: ${tvar('colors.neutrals.grey3')} solid 0.1rem;
  padding: ${tvar('space.x2')};
  margin-bottom: ${tvar('space.x2')};
  width: 100%;
  background: transparent;
  color: ${tvar('colors.typography.default')};
  white-space: nowrap;
  overflow-x: auto;
  user-select: all;
`;
